import React from 'react';

import { FormItemClasses, FormItemProps } from '@components/Forms/FormItem';
import { omit } from 'lodash-es';

export interface BaseInputProps {
  name: string;
  label?: React.ReactNode;
  noLabel?: boolean;
  noErrorMessage?: boolean;
  helperText?: string;
  formClasses?: FormItemClasses;
  itemVariant?: FormItemProps['variant'];
  itemErrorVariant?: FormItemProps['errorVariant'];
}

export const makeFormItemProps = (props: BaseInputProps): FormItemProps => {
  const {
    name,
    label,
    formClasses,
    helperText,
    noLabel,
    noErrorMessage,
    itemVariant,
    itemErrorVariant,
  } = props;

  return {
    name,
    label: <label htmlFor={name}>{label}</label>,
    classes: formClasses,
    helperText,
    noLabel,
    noErrorMessage,
    variant: itemVariant,
    errorVariant: itemErrorVariant,
  };
};

export const extractOwnProps = <T extends BaseInputProps>(props: T) => {
  return omit(props, [
    'name',
    'label',
    'formClasses',
    'helperText',
    'noLabel',
    'hintText',
    'hintTitle',
    'itemVariant',
    'itemErrorVariant',
  ]);
};
